import api from '../index'

export async function signInWithEmailAndPassword(
  email: string,
  password: string
) {
  try {
    const response = await api.instance.post('/auth/login', {
      email,
      password,
    })

    const { access_token, refresh_token } = response.data

    return {
      access: access_token,
      refresh: refresh_token,
    }
  } catch (error) {
    throw error
  }
}

export async function currentUser(email: string) {
  try {
    const response = await api.instance.get(`/users/${email}`)

    return response.data
  } catch (error) {
    throw error
  }
}

export async function updateProfile(
  email: string,
  payload: {
    name?: string
    email?: string
    avatar?: any
    password?: string
  },
  hash?: string
) {
  const formData = new FormData()
  if (payload.name) formData.append('name', payload.name)
  if (payload.email) formData.append('email', payload.email)
  if (payload.avatar) formData.append('avatar', payload.avatar)
  if (payload.password) formData.append('password', payload.password)

  try {
    const response = await api.instance.put(`/users/${email}`, formData, {
      headers: {
        'x-oob-code': hash || undefined,
      },
    })

    return response.data
  } catch (error) {
    throw error
  }
}

export async function resetPassword(email: string) {
  try {
    const response = await api.instance.delete(`/users/${email}/password`)

    return response.data
  } catch (error) {
    throw error
  }
}

export async function updatePassword(
  email: string,
  passwords: {
    new: string
    current?: string
  },
  hash?: string
) {
  try {
    const response = await api.instance.patch(
      `/users/${email}/password`,
      {
        password: passwords.new,
        currentPassword: passwords?.current || undefined,
      },
      {
        params: {
          hash: hash || undefined,
        },
      }
    )

    return response.data
  } catch (error) {
    throw error
  }
}

export async function confirmEmailVerificationCode(
  email: string,
  code: string
) {
  try {
    const response = await api.instance.put(`/users/${email}/email`, {
      verificationCode: code,
    })

    return response.data
  } catch (error) {
    throw error
  }
}
